import Vue from 'vue'
import App from './App.vue'

// Router + Store + Sync
import router from './router'
import store from './store'
import { sync } from 'vuex-router-sync'
sync(store, router)

// Font Awesome
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { far } from '@fortawesome/pro-regular-svg-icons'
import { fal } from '@fortawesome/pro-light-svg-icons'
import { fas } from '@fortawesome/pro-solid-svg-icons'
import { fad } from '@fortawesome/pro-duotone-svg-icons'
import { faPagelines } from '@fortawesome/free-brands-svg-icons'
library.add(fas, far, faPagelines, fad, fal)
Vue.component('fa', FontAwesomeIcon)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
